/* eslint-disable max-len */
import i18next, {init, changeLanguage} from "i18next";
// Start Layouts Common (Shared)
import SharedEn from "../Assets/I18n/en.json";
import SharedAr from "../Assets/I18n/ar.json";
import SharedTr from "../Assets/I18n/tr.json";
import SharedRo from "../Assets/I18n/ro.json";
import SharedSp from "../Assets/I18n/sp.json";
import SharedEl from "../Assets/I18n/el.json";
import SharedDu from "../Assets/I18n/du.json";
import SharedDe from "../Assets/I18n/de.json";
import SharedFr from "../Assets/I18n/fr.json";
// End Layouts Common (Shared)
// Start Account Views
import LoginViewEn from "../Views/Accounts/Login/I18n/en.json";
import LoginViewAr from "../Views/Accounts/Login/I18n/ar.json";
import LoginViewTr from "../Views/Accounts/Login/I18n/tr.json";
import LoginViewRo from "../Views/Accounts/Login/I18n/ro.json";
import LoginViewSp from "../Views/Accounts/Login/I18n/sp.json";
import LoginViewEl from "../Views/Accounts/Login/I18n/el.json";
import LoginViewDu from "../Views/Accounts/Login/I18n/du.json";
import LoginViewDe from "../Views/Accounts/Login/I18n/de.json";
import LoginViewFr from "../Views/Accounts/Login/I18n/fr.json";
// End Account Views

// Start Layouts
import HeaderViewEn from "../Layouts/Home/Sections/Header/I18n/en.json";
import HeaderViewAr from "../Layouts/Home/Sections/Header/I18n/ar.json";
import HeaderViewTr from "../Layouts/Home/Sections/Header/I18n/tr.json";
import HeaderViewRo from "../Layouts/Home/Sections/Header/I18n/ro.json";
import HeaderViewSp from "../Layouts/Home/Sections/Header/I18n/sp.json";
import HeaderViewEl from "../Layouts/Home/Sections/Header/I18n/el.json";
import HeaderViewDu from "../Layouts/Home/Sections/Header/I18n/du.json";
import HeaderViewDe from "../Layouts/Home/Sections/Header/I18n/de.json";
import HeaderViewFr from "../Layouts/Home/Sections/Header/I18n/fr.json";
// End Layouts

// End InternalVacancies

// Start InternalVacancies Details
import InternalVacanciesDetailsEn from "../Views/Home/internal-vacancies/JobDetailsView/I18n/en.json";
import InternalVacanciesDetailsAr from "../Views/Home/internal-vacancies/JobDetailsView/I18n/ar.json";
import InternalVacanciesDetailsTr from "../Views/Home/internal-vacancies/JobDetailsView/I18n/tr.json";
import InternalVacanciesDetailsRo from "../Views/Home/internal-vacancies/JobDetailsView/I18n/ro.json";
import InternalVacanciesDetailsSp from '../Views/Home/internal-vacancies/JobDetailsView/I18n/sp.json';
import InternalVacanciesDetailsEl from "../Views/Home/internal-vacancies/JobDetailsView/I18n/el.json";
import InternalVacanciesDetailsDu from "../Views/Home/internal-vacancies/JobDetailsView/I18n/du.json";
import InternalVacanciesDetailsDe from "../Views/Home/internal-vacancies/JobDetailsView/I18n/de.json";
import InternalVacanciesDetailsFr from "../Views/Home/internal-vacancies/JobDetailsView/I18n/fr.json";

// End InternalVacancies Details

// Start My Profile Details
import MyProfileViewEn from "../Views/Home/my-profile/I18n/en.json";
import MyProfileViewAr from "../Views/Home/my-profile/I18n/ar.json";
import MyProfileViewTr from "../Views/Home/my-profile/I18n/tr.json";
import MyProfileViewRo from "../Views/Home/my-profile/I18n/ro.json";
import MyProfileViewSp from '../Views/Home/my-profile/I18n/sp.json';
import MyProfileViewEl from "../Views/Home/my-profile/I18n/el.json";
import MyProfileViewDu from "../Views/Home/my-profile/I18n/du.json";
import MyProfileViewDe from "../Views/Home/my-profile/I18n/de.json";
import MyProfileViewFr from "../Views/Home/my-profile/I18n/fr.json";
// End My Profile Details

// Start Job Requisition Details
import JobRequisitionViewEn from "../Views/Home/job-requisition/I18n/en.json";
import JobRequisitionViewAr from "../Views/Home/job-requisition/I18n/ar.json";
import JobRequisitionViewTr from "../Views/Home/job-requisition/I18n/tr.json";
import JobRequisitionViewRo from "../Views/Home/job-requisition/I18n/ro.json";
import JobRequisitionViewSp from "../Views/Home/job-requisition/I18n/sp.json";
import JobRequisitionViewEl from "../Views/Home/job-requisition/I18n/el.json";
import JobRequisitionViewDu from "../Views/Home/job-requisition/I18n/du.json";
import JobRequisitionViewDe from "../Views/Home/job-requisition/I18n/de.json";
import JobRequisitionViewFr from "../Views/Home/job-requisition/I18n/fr.json";
// End Job Requisition Details

// Start Approval Tracking
import ApprovalsTrackingViewEn from "../Views/Home/approvals-tracking/I18n/en.json";
import ApprovalsTrackingViewAr from "../Views/Home/approvals-tracking/I18n/ar.json";
import ApprovalsTrackingViewTr from "../Views/Home/approvals-tracking/I18n/tr.json";
import ApprovalsTrackingViewRo from "../Views/Home/approvals-tracking/I18n/ro.json";
import ApprovalsTrackingViewSp from '../Views/Home/approvals-tracking/I18n/sp.json';
import ApprovalsTrackingViewEl from "../Views/Home/approvals-tracking/I18n/el.json";
import ApprovalsTrackingViewDu from "../Views/Home/approvals-tracking/I18n/du.json";
import ApprovalsTrackingViewDe from "../Views/Home/approvals-tracking/I18n/de.json";
import ApprovalsTrackingViewFr from "../Views/Home/approvals-tracking/I18n/fr.json";
// End Approval Tracking
// Start Job page
import JobCandidatesDetailsViewEn from "../Views/Home/job-candidates-details/I18n/en.json";
import JobCandidatesDetailsViewAr from "../Views/Home/job-candidates-details/I18n/ar.json";
import JobCandidatesDetailsViewTr from "../Views/Home/job-candidates-details/I18n/tr.json";
import JobCandidatesDetailsViewRo from "../Views/Home/job-candidates-details/I18n/ro.json";
import JobCandidatesDetailsViewSp from "../Views/Home/job-candidates-details/I18n/sp.json";
import JobCandidatesDetailsViewEl from "../Views/Home/job-candidates-details/I18n/el.json";
import JobCandidatesDetailsViewDu from "../Views/Home/job-candidates-details/I18n/du.json";
import JobCandidatesDetailsViewDe from "../Views/Home/job-candidates-details/I18n/de.json";
import JobCandidatesDetailsViewFr from "../Views/Home/job-candidates-details/I18n/fr.json";
// Start internal vacancies new
import JobsViewEn from "../Views/Home/internal-vacancies/I18n/en.json";
import JobsViewAr from "../Views/Home/internal-vacancies/I18n/ar.json";
import JobsViewTr from "../Views/Home/internal-vacancies/I18n/tr.json";
import JobsViewRo from "../Views/Home/internal-vacancies/I18n/ro.json";
import JobsViewSp from '../Views/Home/internal-vacancies/I18n/sp.json';
import JobsViewEl from "../Views/Home/internal-vacancies/I18n/el.json";
import JobsViewDu from "../Views/Home/internal-vacancies/I18n/du.json";
import JobsViewDe from "../Views/Home/internal-vacancies/I18n/de.json";
import JobsViewFr from "../Views/Home/internal-vacancies/I18n/fr.json";

// Tasks
import TasksViewEn from "../Views/Home/tasks/I18n/en.json";
import TasksViewAr from "../Views/Home/tasks/I18n/ar.json";
import TasksViewDe from "../Views/Home/tasks/I18n/de.json";
import TasksViewDu from "../Views/Home/tasks/I18n/du.json";
import TasksViewEl from "../Views/Home/tasks/I18n/el.json";
import TasksViewFr from "../Views/Home/tasks/I18n/fr.json";
import TasksViewRo from "../Views/Home/tasks/I18n/ro.json";
import TasksViewSp from "../Views/Home/tasks/I18n/sp.json";
import TasksViewTr from "../Views/Home/tasks/I18n/tr.json";

// Start Approval Tracking
import JobsTrackingViewEn from "../Views/Home/job-tracking/I18n/en.json";
import JobsTrackingViewAr from "../Views/Home/job-tracking/I18n/ar.json";
import JobsTrackingViewTr from "../Views/Home/job-tracking/I18n/tr.json";
import JobsTrackingViewRo from "../Views/Home/job-tracking/I18n/ro.json";
import JobsTrackingViewEl from "../Views/Home/job-tracking/I18n/el.json";
import JobsTrackingViewFr from "../Views/Home/job-tracking/I18n/fr.json";
import JobsTrackingViewDu from "../Views/Home/job-tracking/I18n/du.json";
import JobsTrackingViewDe from "../Views/Home/job-tracking/I18n/de.json";
import JobsTrackingViewSp from "../Views/Home/job-tracking/I18n/sp.json";

// Start Visa
import VisaViewEn from "../Views/Home/visa/i18n/en.json";
import VisaViewAr from "../Views/Home/visa/i18n/ar.json";
import VisaViewTr from "../Views/Home/visa/i18n/tr.json";
import VisaViewRo from "../Views/Home/visa/i18n/ro.json";
import VisaViewEl from "../Views/Home/visa/i18n/el.json";
import VisaViewFr from "../Views/Home/visa/i18n/fr.json";
import VisaViewSp from "../Views/Home/visa/i18n/sp.json";
import VisaViewDu from "../Views/Home/visa/i18n/du.json";
import VisaViewDe from "../Views/Home/visa/i18n/de.json";
// End Visa

// Start Home Views
// Start Contacts Module Views
// End Contacts Module Views
// End Home Views

// Email integration page
import EmailIntegrationPageEn from "../Views/Home/mailbox/i18n/en.json";
import EmailIntegrationPageAr from "../Views/Home/mailbox/i18n/ar.json";
import EmailIntegrationPageEl from "../Views/Home/mailbox/i18n/el.json";
import EmailIntegrationPageFr from "../Views/Home/mailbox/i18n/fr.json";
import EmailIntegrationPageSp from "../Views/Home/mailbox/i18n/sp.json";
import EmailIntegrationPageDu from "../Views/Home/mailbox/i18n/du.json";
import EmailIntegrationPageDe from "../Views/Home/mailbox/i18n/de.json";
import EmailIntegrationPageRo from "../Views/Home/mailbox/i18n/ro.json";
import EmailIntegrationPageTr from "../Views/Home/mailbox/i18n/tr.json";

import {GlobalRerender} from "./Middleware.Helper";
import {SystemLanguagesConfig} from "../Configs";

const languageInit = () => {
  if (localStorage.getItem("localization")) {
    changeLanguage(localStorage.getItem("localization"));
    const isRtl = i18next.dir(localStorage.getItem("localization")) === "rtl";
    if (isRtl) {
      const direction = i18next.dir(localStorage.getItem("localization"));
      document.body.classList.add(direction);
      document.body.setAttribute("dir", direction);
      document.documentElement.lang = localStorage.getItem("localization");
    }
  } else localStorage.setItem("localization", "en");
};

export function localizationInit() {
  init({
    interpolation: {escapeValue: false}, // React already does escaping
    fallbackLng: Object.keys(SystemLanguagesConfig),
    lng: "en", // language to use
    resources: {
      en: {
        Shared: SharedEn,
        HeaderView: HeaderViewEn,
        LoginView: LoginViewEn,
        JobDetailsView: InternalVacanciesDetailsEn,
        MyProfileView: MyProfileViewEn,
        JobRequisitionView: JobRequisitionViewEn,
        ApprovalsTrackingView: ApprovalsTrackingViewEn,
        JobCandidatesDetailsView: JobCandidatesDetailsViewEn,
        EmailIntegrationPage: EmailIntegrationPageEn,
        JobsView: JobsViewEn,
        VisaView: VisaViewEn,
        TasksView: TasksViewEn,
        JobsTrackingView:JobsTrackingViewEn,
      },
      ar: {
        Shared: SharedAr,
        HeaderView: HeaderViewAr,
        LoginView: LoginViewAr,
        JobDetailsView: InternalVacanciesDetailsAr,
        MyProfileView: MyProfileViewAr,
        JobRequisitionView: JobRequisitionViewAr,
        ApprovalsTrackingView: ApprovalsTrackingViewAr,
        JobCandidatesDetailsView: JobCandidatesDetailsViewAr,
        EmailIntegrationPage: EmailIntegrationPageAr,
        JobsView: JobsViewAr,
        VisaView: VisaViewAr,
        TasksView: TasksViewAr,
        JobsTrackingView:JobsTrackingViewAr,

      },
      tr: {
        Shared: SharedTr,
        HeaderView: HeaderViewTr,
        LoginView: LoginViewTr,
        JobDetailsView: InternalVacanciesDetailsTr,
        MyProfileView: MyProfileViewTr,
        JobRequisitionView: JobRequisitionViewTr,
        ApprovalsTrackingView: ApprovalsTrackingViewTr,
        JobCandidatesDetailsView: JobCandidatesDetailsViewTr,
        EmailIntegrationPage: EmailIntegrationPageTr,
        JobsView: JobsViewTr,
        VisaView: VisaViewTr,
        TasksView: TasksViewTr,
        JobsTrackingView:JobsTrackingViewTr,

      },
      ro: {
        Shared: SharedRo,
        HeaderView: HeaderViewRo,
        LoginView: LoginViewRo,
        JobDetailsView: InternalVacanciesDetailsRo,
        MyProfileView: MyProfileViewRo,
        JobRequisitionView: JobRequisitionViewRo,
        ApprovalsTrackingView: ApprovalsTrackingViewRo,
        JobCandidatesDetailsView: JobCandidatesDetailsViewRo,
        EmailIntegrationPage: EmailIntegrationPageRo,
        JobsView: JobsViewRo,
        VisaView: VisaViewRo,
        TasksView: TasksViewRo,
        JobsTrackingView:JobsTrackingViewRo,

      },
      sp: {
        Shared: SharedSp,
        HeaderView: HeaderViewSp,
        LoginView: LoginViewSp,
        JobDetailsView: InternalVacanciesDetailsSp,
        MyProfileView: MyProfileViewSp,
        JobRequisitionView: JobRequisitionViewSp,
        ApprovalsTrackingView: ApprovalsTrackingViewSp,
        JobCandidatesDetailsView: JobCandidatesDetailsViewSp,
        EmailIntegrationPage: EmailIntegrationPageSp,
        JobsView: JobsViewSp,
        VisaView: VisaViewSp,
        TasksView: TasksViewSp,
        JobsTrackingView:JobsTrackingViewSp,

      },
      el: {
        Shared: SharedEl,
        HeaderView: HeaderViewEl,
        LoginView: LoginViewEl,
        JobDetailsView: InternalVacanciesDetailsEl,
        MyProfileView: MyProfileViewEl,
        JobRequisitionView: JobRequisitionViewEl,
        ApprovalsTrackingView: ApprovalsTrackingViewEl,
        JobCandidatesDetailsView: JobCandidatesDetailsViewEl,
        EmailIntegrationPage: EmailIntegrationPageEl,
        JobsView: JobsViewEl,
        VisaView: VisaViewEl,
        TasksView: TasksViewEl,
        JobsTrackingView:JobsTrackingViewEl,

      },
      du: {
        Shared: SharedDu,
        HeaderView: HeaderViewDu,
        LoginView: LoginViewDu,
        JobDetailsView: InternalVacanciesDetailsDu,
        MyProfileView: MyProfileViewDu,
        JobRequisitionView: JobRequisitionViewDu,
        ApprovalsTrackingView: ApprovalsTrackingViewDu,
        JobCandidatesDetailsView: JobCandidatesDetailsViewDu,
        EmailIntegrationPage: EmailIntegrationPageDu,
        JobsView: JobsViewDu,
        VisaView: VisaViewDu,
        TasksView: TasksViewDu,
        JobsTrackingView:JobsTrackingViewDu,

      },
      de: {
        Shared: SharedDe,
        HeaderView: HeaderViewDe,
        LoginView: LoginViewDe,
        JobDetailsView: InternalVacanciesDetailsDe,
        MyProfileView: MyProfileViewDe,
        JobRequisitionView: JobRequisitionViewDe,
        ApprovalsTrackingView: ApprovalsTrackingViewDe,
        JobCandidatesDetailsView: JobCandidatesDetailsViewDe,
        EmailIntegrationPage: EmailIntegrationPageDe,
        JobsView: JobsViewDe,
        VisaView: VisaViewDe,
        TasksView: TasksViewDe,
        JobsTrackingView:JobsTrackingViewDe,

      },
      fr: {
        Shared: SharedFr,
        HeaderView: HeaderViewFr,
        LoginView: LoginViewFr,
        JobDetailsView: InternalVacanciesDetailsFr,
        MyProfileView: MyProfileViewFr,
        JobRequisitionView: JobRequisitionViewFr,
        ApprovalsTrackingView: ApprovalsTrackingViewFr,
        JobCandidatesDetailsView: JobCandidatesDetailsViewFr,
        EmailIntegrationPage: EmailIntegrationPageFr,
        JobsView: JobsViewFr,
        VisaView: VisaViewFr,
        TasksView: TasksViewFr,
        JobsTrackingView: JobsTrackingViewFr,
      },
    },
  });

  languageInit();
}

export const languageChange = (currentLanguage) => {
  const direction = i18next.dir(currentLanguage);
  localStorage.setItem("localization", currentLanguage);
  if (document.body.classList.contains("rtl"))
    document.body.classList.remove("rtl");
  if (document.body.classList.contains("lrt"))
    document.body.classList.remove("lrt");
  document.body.classList.add(direction);
  document.body.setAttribute("dir", direction);
  document.documentElement.lang = currentLanguage;
  changeLanguage(currentLanguage);
  GlobalRerender();
};
localizationInit();
